import { render } from "./ArtsAndPerformanceView.vue?vue&type=template&id=0ec617f3&scoped=true"
const script = {}

import "./ArtsAndPerformanceView.vue?vue&type=style&index=0&id=0ec617f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec617f3"]])

export default __exports__